import '../scss/main.scss';

import { initNavigation } from './modules/navigation.js';
import { initBackToTop } from './modules/back-to-top.js';
import { initSwiperCarousel } from './modules/swiper-carousel.js';
import { initAOS } from './modules/aos.js';
document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
  initBackToTop();
  initSwiperCarousel();
  initAOS();
});
